import { useState } from "react";
import { Leaf } from "@phosphor-icons/react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { DIET_LABELS } from "@/lib/diets";

export default function DietProfileSettings() {
  const { user, setUser } = useAuth();
  const [sel, setSel] = useState(user?.diet_profile || []);
  const [saving, setSaving] = useState(false);
  const dirty = [...sel].sort().join() !== [...(user?.diet_profile || [])].sort().join();
  const toggle = (d) => setSel((s) => (s.includes(d) ? s.filter((x) => x !== d) : [...s, d]));

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/me/diet-profile", { diets: sel });
      setUser((u) => ({ ...u, diet_profile: data.diet_profile }));
      toast.success(data.diet_profile.length ? "Diet profile saved" : "Diet profile cleared");
    } catch {
      toast.error("Couldn't save your diet profile");
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="card-recipe" data-testid="profile-diet-settings">
      <div className="flex items-center gap-3 mb-3">
        <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center">
          <Leaf size={20} weight="duotone" className="text-emerald-700" />
        </div>
        <h2 className="font-display text-2xl font-black text-rf-ink">Household diet</h2>
      </div>
      <p className="text-sm text-rf-ink-soft mb-5 leading-relaxed">
        Pick the diets your household follows. Search, the Directory, voice answers, &ldquo;plan my week&rdquo; and the
        leftovers finder will only suggest recipes with every badge you tick — with a one-tap &ldquo;Show everything&rdquo; whenever you need it.
      </p>
      <div className="flex flex-wrap gap-2 mb-5">
        {Object.entries(DIET_LABELS).map(([d, label]) => {
          const on = sel.includes(d);
          return (
            <button key={d} type="button" aria-pressed={on} onClick={() => toggle(d)} data-testid={`diet-profile-${d}`}
              className={`px-3 py-1.5 rounded-full text-sm font-bold border transition-colors ${on ? "bg-emerald-700 text-white border-emerald-700" : "bg-white text-rf-ink-soft border-rf-ink/15 hover:border-emerald-700/50"}`}>
              {label}
            </button>
          );
        })}
      </div>
      <button type="button" onClick={save} disabled={!dirty || saving} data-testid="diet-profile-save" className="btn-amber disabled:opacity-50">
        {saving ? "Saving…" : "Save diet profile"}
      </button>
      <p className="text-xs text-rf-ink-soft mt-3">Badges are based on listed ingredients — always check labels for allergies.</p>
    </section>
  );
}
